import {useEffect, useState,Fragment} from "react";
import {useNavigate,useParams} from "react-router-dom";


import {useDispatch} from "react-redux";
import MainLayout from "../../../commons/layout/MainLayout/index";

import HeaderHs2 from "../../../commons/components/Header/headerHs2";
import ROUTERS from "../../../commons/constans/router";
import InfiniteScroll from 'react-infinite-scroll-component';
import _styles from "./_styles.scss"
import moment from "moment";
import ListItemComponent from "../../../commons/components/List/ListItemComponent";
import SkeletonLoadingComponent from "../../../commons/components/SkeletonLoading";


const FaqPageComponent = (props) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [faqList, setFaqList] = useState([])
    const [page, setPage] = useState(1)
    const [statusLoading, setStatusLoading] = useState(true)
    const [statusListEmpty, setStatusListEmpty] = useState(false)

    useEffect(() => {
        if(props.loadMore){
            setStatusLoading(true)
        }else {
            setStatusLoading(false)
        }
    }, [props]);

    useEffect(() => {
        let dataList = []
        if(faqList.length > 0) {
            dataList= [...faqList,...(props?.faqData?.data || [])]
        }else {
            dataList=props?.faqData?.data || [];
        }
        setFaqList(dataList)
    }, [props?.faqData?.data]);

    useEffect(() => {

        if(faqList.length > 0) {
            setStatusListEmpty(true)
        }else {
            setStatusListEmpty(false)
        }

    }, [faqList]);

    const backMenuHome = () => {
      navigate(ROUTERS.HOME, {
        state: {
            menuStatus: true
        }
      })
    }

    const openDetail = (id) => {
        let url = ROUTERS.faq_DETAIL
        url = url.replace(':id',id)
        navigate(url)
    }
    const fetchMoreData = () => {
        let dataFetch = [...faqList];
        if (props?.faqData?.from < props?.faqData?.last_page && statusLoading) {
            let pageLoad = page + 1;
            setPage(pageLoad)
            let params= '?page='+pageLoad+'&limit=10'
            props.fetchData(params)
        }
    }

    const loadingDiv = <div className="lists__item loading-content">
        <div className="lists__item__content w-100">
            <span className="w-100">
                <SkeletonLoadingComponent circle={false} width="40px" height="14px"/>
            </span>
            <h3 className="w-100">
                <SkeletonLoadingComponent circle={false} width="100%" height="14px"/>
            </h3>
            </div>
            <div className="lists__item__action pt-2">
                {/*<SkeletonLoadingComponent circle={false} width="20px" height="14px"/>*/}
        </div>
    </div>

    return (
        <MainLayout pageID={"faq-list"} displayBottomNav={false} >
            <HeaderHs2
                title={"자주하는 질문"}
                labelLeft={true}
                labelRight={false}
                handleLabelLeft={backMenuHome}
            />
            <div className="wrapper">

                <section className="lists">
                    {props.loading ? ([...Array(10).keys()].map(e => (
                                    <Fragment key={e}>
                                        {loadingDiv}
                                    </Fragment>
                                ))) : ( faqList.length > 0 ? <InfiniteScroll
                            dataLength={faqList.length}
                            next={fetchMoreData}
                            hasMore={statusLoading}
                            loader={loadingDiv}
                        >
                            {faqList.map((value,key)=>(
                                <Fragment key={key}>
                                    <ListItemComponent
                                        subTitle={moment(value.created_at).format('Y-MM-DD')}
                                        title={value.title}
                                        description={false}
                                        rightArrow={true}
                                        accordion={true}
                                        downArrowIcon={'/images/icon_arrow_down_s.svg'}
                                        accordionContent={
                                            <>
                                                {/* <span className={'time-create-answer'}>{moment(value.created_at).format('Y-MM-DD')}</span> */}
                                                {
                                                    value?.attachment_url?.url && <div className="box-img">
                                                        <img className="img" src={value?.attachment_url?.url || ''} alt="" />
                                                    </div>
                                                }
                                                <div className="lists__item__pan__content" dangerouslySetInnerHTML={{__html: value.content}} />
                                                <div className="lists__item__pan__detail">
                                                    <span><img src="/images/icon_callcenter.svg"/></span>
                                                    <span className={'pr-1'}>고객센터</span>
                                                    <span> 02-2135-5265</span>
                                                </div>
                                            </>}
                                    />
                                </Fragment>

                            ))}


                        </InfiniteScroll> :'')}


                    {/*{statusListEmpty ? '' : (<div className="lists__empty">*/}
                    {/*    <img src="/images/img_notfound.svg" />*/}
                    {/*    <p className="lists__empty__description">나의 문의 내역이 없습니다.</p>*/}
                    {/*</div>)}*/}


                </section>

            </div>
        </MainLayout>
    );
};

export default FaqPageComponent;
